import styled from 'styled-components';

export const ConfirmationContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: clamp(1.5rem, 3vw, 2rem);
  max-width: 600px;
  margin: clamp(1.5rem, 4vw, 3rem) auto;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
`;

export const ConfirmationIcon = styled.div`
  color: ${props => props.theme.colors.primary};
  font-size: clamp(3rem, 5vw, 4rem);
  margin-bottom: clamp(1rem, 2vw, 1.5rem);
`;

export const ConfirmationTitle = styled.h2`
  font-size: clamp(1.25rem, 2vw, 1.5rem);
  font-weight: 700;
  margin-bottom: 1rem;
  color: ${props => props.theme.colors.text};
`;

export const ConfirmationMessage = styled.p`
  font-size: clamp(0.875rem, 1.25vw, 1rem);
  text-align: center;
  margin-bottom: clamp(1.5rem, 3vw, 2rem);
  color: ${props => props.theme.colors.grey_text};
  line-height: 1.5;
`;

export const ConfirmationButton = styled.button`
  background-color: ${props => props.theme.colors.primary};
  color: #fff;
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 4px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: ${props => props.theme.colors.primary_dark || props.theme.colors.primary};
  }
`;


export const Container = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: clamp(1rem, 2vw, 1.25rem);
  gap: 0.5rem;
`;

export const TitleContainer = styled.div`
  width: 100%;
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0.5rem;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const DepositContainer = styled.div`
  width: 65%;
  background-color: ${props => props.theme.colors.card};
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  padding: clamp(1.5rem, 3vw, 3.125rem);
  display: flex;
  flex-direction: column;
  height: 80vh;

  @media (max-width: 1024px) {
    width: 60%;
    padding: clamp(1rem, 2vw, 1.875rem);
  }

  @media (max-width: 768px) {
    width: 100%;
    height: auto;
    padding: clamp(0.75rem, 1.5vw, 1.25rem);
  }
`;

export const Pagamanto = styled.div`
  width: 35%;
  background-color: ${props => props.theme.colors.card};
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  padding: clamp(0.75rem, 1.5vw, 1.25rem);
  height: 17rem;

  @media (max-width: 1024px) {
    width: 40%;
  }

  @media (max-width: 768px) {
    width: 100%;
    height: auto;
  }
`;

export const InputContainer = styled.div`
  padding-block: clamp(1.5rem, 3vw, 2.5rem);

  @media (max-width: 768px) {
    padding-block: clamp(0.75rem, 1.5vw, 1.25rem);
  }
`;

export const Options = styled.div`
  display: flex;
  max-height: 470px;
  overflow-y: auto;
  flex-direction: column;
  justify-content: space-between;
  gap: clamp(0.75rem, 1.5vw, 1.25rem);

  @media (max-width: 768px) {
    max-height: 300px;
  }
`;

export const Destino = styled.div`
  padding-block: clamp(0.75rem, 1.5vw, 1.25rem);
`;

export const Subtitle = styled.span`
  color: ${props => props.theme.colors.grey_text};
  margin-bottom: 0.1875rem;
`;

export const CheckboxContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;
